import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { NgbDropdownModule, NgbAccordionModule, NgbNavModule, NgbProgressbarModule, NgbTooltipModule, NgbPopoverModule, NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { FullCalendarModule } from '@fullcalendar/angular';
import { PagesRoutingModule } from './pages-routing.modules';
import { SharedModule } from '../shared/shared.module';
import { CommentsModule } from '../features/comments/comments.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrganizationComponent } from './dashboards/organization/organization.component';
import { TimekeeperDashboardComponent } from './dashboards/timekeeper-dashboard.component';
import { LpcDashboardComponent } from './dashboards/lpc-dashboard/lpc-dashboard.component';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { PickListModule } from 'primeng/picklist';
import { UsersGridComponent } from './users-grid/users-grid.component';
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from 'primeng/calendar';
import { MattersComponent } from './dashboards/matters/matters.component';
import { TaskGridComponent } from './tasks-grid/task-grid.component';
import { MessageService } from 'primeng/api';
import { TkAvailabilityComponent } from './tk-availability/tk-availability/tk-availability.component';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import { TaskCatalogueComponent } from './task-catalogue/task-catalogue.component';
import { ProjectsTemplateComponent } from './projects-template/projects-template.component';
import { ProjectsGridComponent } from './projects-grid/projects-grid.component';
import { ProjectContactsManagerComponent } from './projects-grid/project-contacts-manager/project-contacts-manager.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { ViewOrganizationComponent } from './dashboards/organization/view-organization/view-organization.component';
import { TabViewModule } from "primeng/tabview";
import { ViewMatterComponent } from './dashboards/matters/view-matter/view-matter.component';
import { ImportDataComponent } from './../import-data/import-data.component';
import { FileUploadModule } from 'primeng/fileupload';
import { TimeRecordGridComponent } from './time-record-grid/time-record-grid.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TimeRecordExportComponent } from './time-record-export/time-record-export.component';
import { ErrorComponent } from './error/error.component';
import { AppConfigComponent } from './app-config/app-config.component';
import { MinutesToTimePipe } from '../shared/pipes/minutesToString.pipe';
import { PayrollTimeReportComponent } from './payroll-time-report/payroll-time-report.component';
import { ClientTimeReportComponent } from './client-time-report/client-time-report.component';
import { TasksGridViewComponent } from './tasks-grid-view/tasks-grid-view.component';
import { TimeApproverRulesComponent } from './time-approver-rules/time-approver-rules.component';
import { helperService } from '../utils/helper';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { WidgetsModule } from '../features/widgets/widgets.module';
import { HomepageDashboardComponent } from './dashboards/homepage-dashboard/homepage-dashboard.component';
import { ItemsSelectorComponent } from './dashboards/items-selector/items-selector.component';
import { PaymentMethodSettingsComponent } from './payment-method-settings/payment-method-settings.component';
import { EscrowAccountsComponent } from './escrow-accounts/escrow-accounts.component';
import { VendorGridComponent } from './vendor-grid/vendor-grid.component';
import { DisbursementsExportComponent } from './disbursements-export/disbursements-export.component';
import { FieldInfoGridComponent } from './field-info-grid/field-info-grid.component';
import { TooltipModule } from 'primeng/tooltip';
import { ActionTooltipModule } from '../shared/directives/action-tooltip.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TreeModule } from 'primeng/tree'; // Required for p-tree
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { EditorModule } from 'primeng/editor';
import { AuditTableComponent } from '../shared/components/audit-table/audit-table.component';
import { EntitiesModule } from './entities/entities.module';
import { ReminderComponent } from './reminder/reminder.component';
import { ReminderNotificationsComponent } from './reminder-notifications/reminder-notifications.component';
import { GridSettingsMapperComponent } from './grid-settings-mapper/grid-settings-mapper.component';
import { ListboxModule } from 'primeng/listbox';
import { AccordionModule } from 'primeng/accordion';
import { NotificationCenterComponent } from './notification-center/notification-center.component';


@NgModule({
  declarations: [
    OrganizationComponent,
    TimekeeperDashboardComponent,
    LpcDashboardComponent,
    ImportDataComponent,
    UsersGridComponent,
    MattersComponent,
    TaskGridComponent,
    LoadingSpinnerComponent,
    TkAvailabilityComponent,
    TaskCatalogueComponent,
    ProjectsTemplateComponent,
    ProjectsGridComponent,
    ProjectContactsManagerComponent,
    ViewOrganizationComponent,
    ViewMatterComponent,
    TimeRecordGridComponent,
    TimeRecordExportComponent,
    ErrorComponent,
    AppConfigComponent,
    MinutesToTimePipe,
    PayrollTimeReportComponent,
    ClientTimeReportComponent,
    TasksGridViewComponent,
    TimeApproverRulesComponent,
    HomepageDashboardComponent,
    ItemsSelectorComponent,
    PaymentMethodSettingsComponent,
    EscrowAccountsComponent,
    VendorGridComponent,
    DisbursementsExportComponent,
    FieldInfoGridComponent,
    AuditTableComponent,
    ReminderComponent,
    ReminderNotificationsComponent,
    GridSettingsMapperComponent,
    NotificationCenterComponent
  ],
  imports: [
    CommonModule,
    WidgetsModule,
    FullCalendarModule,
    TableModule,
    CalendarModule,
    PickListModule,
    DropdownModule,
    MessagesModule,
    MessageModule,
    PagesRoutingModule,
    NgbDropdownModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbProgressbarModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    MultiSelectModule,
    SharedModule,
    CommentsModule,
    DialogModule,
    ButtonModule,
    NgbModalModule,
    TabViewModule,
    FileUploadModule,
    RadioButtonModule,
    NgxChartsModule,
    TooltipModule,
    ActionTooltipModule,
    AutoCompleteModule,
    TreeModule,
    InputTextModule,
    ProgressSpinnerModule,
    EditorModule,
    EntitiesModule,
    ListboxModule,
    AccordionModule
    
    
  ],
  providers:[ DatePipe,
            helperService
            // loadUserRoles() moved to the single post-keycloak APP_INITIALIZER in AppModule
            // so it runs with a bearer token instead of racing keycloak.init -> 401.
  ]
})
export class PagesModule { }
